import Swiper from 'swiper';
import 'swiper/css';
import { FreeMode, Navigation } from 'swiper/modules';

export default class Faq {
    constructor() {
        this.sections = document.querySelectorAll('.categorized-faq');
        this.ready();
    }

    ready() {
        this.sections.forEach((section) => {
            const allQuestions = section.querySelectorAll('.faq-item');
            allQuestions.forEach((question) => {
                const questionTitle = question.querySelector('.title');
                questionTitle.addEventListener('click', () => {
                    question.classList.toggle('active');
                });
            });

            const swiper = new Swiper(section.querySelector('.swiper-categorized-faq'), {
                modules: [Navigation, FreeMode],
                slidesPerView: 'auto',
                spaceBetween: 12,
                allowTouchMove: true,
                freeMode: true,
                navigation: {
                    nextEl: section.querySelector('.swiper-button-next'),
                    prevEl: section.querySelector('.swiper-button-prev'),
                },
            });

            const allFaqItems = section.querySelectorAll('.faq-item');

            section.querySelectorAll('.btnFilterCategorie').forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    const categorie = btn.dataset.category;
                    console.log(categorie);
                    if (categorie == 'todos') {
                        allFaqItems.forEach((item) => {
                            item.classList.remove('hidden');
                        });
                    } else {
                        allFaqItems.forEach((item) => {
                            if (!item.classList.contains('faq-item-' + categorie)) {
                                item.classList.add('hidden');
                            } else {
                                item.classList.remove('hidden');
                            }
                        });
                    }

                    section.querySelectorAll('.btnFilterCategorie').forEach((btn2) => {
                        btn2.classList.remove('active');
                    });
                    btn.classList.add('active');
                });
            });
            section.querySelectorAll('.btnFilterCategorie')[0].classList.add('active');
        });
    }
}

if (document.querySelector('.categorized-faq')) {
    try {
        new Faq();
    } catch (e) {}
}
